import FeatureGates from '@atlaskit/feature-gate-js-client';

import { GateNames } from './gate-keys';

const EAP_PERMS_GATE = 'atlas_enable_edit_permissions';
const GA_PERMS_GATE = 'townsquare_goals_default_edit_access';

export function fg(gateName: GateNames): boolean {
	// Logic for edit permissions M1 gates
	if (gateName === EAP_PERMS_GATE || gateName === GA_PERMS_GATE) {
		// GA release has all permissions related features enabled
		const isPermsGAEnabled = FeatureGates.checkGate(GA_PERMS_GATE);
		if (isPermsGAEnabled) {
			return true;
		}

		// EAP release cohort has only EAP features enabled
		const isEAPCohort = FeatureGates.checkGate(EAP_PERMS_GATE);
		return gateName === EAP_PERMS_GATE && isEAPCohort;
	}

	return FeatureGates.checkGate(gateName);
}
